import Vue from 'vue'
import Router from 'vue-router'
import FaqView from './views/Faq.vue'
import HomeView from './views/Home.vue'
import LoginView from './views/Login.vue'
import PasswordResetView from './views/PasswordReset.vue'
import ProtocolsEditView from './views/Protocols/Edit.vue'
import ProtocolsListView from './views/Protocols/List.vue'
import SettingsView from './views/Settings.vue'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: HomeView,
            meta: { requiresAuth: true }
        },
        {
            path: '/login',
            component: LoginView
        },
        {
            path: '/passwort-vergessen',
            component: PasswordResetView
        },
        {
            path: '/protokolle',
            component: ProtocolsListView,
            meta: { requiresAuth: true }
        },
        {
            path: '/protokolle/erstellen',
            component: ProtocolsEditView,
            meta: { requiresAuth: true }
        },
        {
            path: '/einstellungen',
            component: SettingsView,
            meta: { requiresAuth: true }
        },
        {
            path: '/hilfe',
            component: FaqView,
            meta: { requiresAuth: true }
        }
    ]
})

router.beforeEach((to, from, next) => {
    const loggedIn = localStorage.getItem('user')

    if (to.matched.some(record => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        if (!loggedIn) {
            return next('/login')
        }
    }

    next()
})

export default router
